import React from 'react';
import classNames from 'classnames';
import {
	Footer
	,Button
	,ArrowItem
	,moment
	,DatePicker
	,PopPicker
} from '@beisen/chaos-ui';

import { covertDateStrForNewDate } from '../../util/helper';
import zhCn from '../../util/zh_CN';
import transLoader from '@beisen/i18n-translation-loader';

function formatToMode(format) {
	let map = {
		'yyyy/MM/dd HH:mm:ss': 'datetime'
		,'yyyy/MM/dd': 'date'
		,'yyyy/MM': 'month'
		,'HH:mm': 'time'
	};
	return map[format] || 'date';
}


function pad(n) {
	return n < 10 ? `0${n}` : n + '';
}

require('./DateRange.scss');

const defaultTranslation = {
	dateRangeStart: '开始',
	dateRangeEnd: '结束',
	dateRangeStartTime: '开始时间',
	dateRangeEndTime: '结束时间',
    clear: '清空',
    confirm: '确定',
	cancel: '取消',
	selectHolder: '点击选择',
    required: '必填'
};
class DateRange extends React.Component {
	constructor(props) {
		super(props);
		const dateInterval = props.text && props.text.split('-');
		this.formatType = this.props.cmp_data.data_format;
		this.pickerMode = formatToMode(this.formatType);
		this.state = {
			startDate: dateInterval && dateInterval[0] || ''
			,endDate: dateInterval && dateInterval[1] ||  ''
			,toBottom: false
			,key: 'start'
			,timeText: ''
		};

		this.handleClear = this.handleClear.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.onClickForm = this.onClickForm.bind(this);
		this.handleSaveDate = this.handleSaveDate.bind(this);
		this.handleClearValue = this.handleClearValue.bind(this);
        this.getDefaulSearchtDate();
        this.translation = Object.assign({}, defaultTranslation, transLoader({
            dateRangeStart: 'date.dateRangeStart',
            dateRangeEnd: 'date.dateRangeEnd',
            dateRangeStartTime: 'date.dateRangeStartTime',
            dateRangeEndTime: 'date.dateRangeEndTime',
            clear: 'common.clear',
            confirm: 'common.confirm',
            cancel: 'common.cancel',
            selectHolder: 'fieldPlaceHolder.selectHolder',
            required: 'common.required'
        }), props.translation);
	}

  	componentWillReceiveProps(nextProps, nextState) {
		const dateInterval = (nextProps.text || '').split('-');
		this.setState({
			startDate: dateInterval[0]
			,endDate: dateInterval[1]
		});
	}


	getDefaulSearchtDate() {
		const d = new Date();
		switch(this.pickerMode) {
			case 'datetime':
				this.defaultStartDate = `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())} 00:00:00`;
				this.defaultEndDate = `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())} 23:59:59`;
				break;
			case 'date':
				this.defaultStartDate = this.defaultEndDate = `${d.getFullYear()}/${pad(d.getMonth() + 1)}/${pad(d.getDate())}`;
				break;
			case 'time':
				this.defaultStartDate = this.defaultEndDate = `${d.getHours()}:${d.getMinutes()}`;
				break;
			case 'month':
				this.defaultStartDate = this.defaultEndDate = `${d.getFullYear()}/${pad(d.getMonth() + 1)}`;
				break;
			default:
				this.defaultStartDate = this.defaultEndDate = `${d.getFullYear()}`;
			break;
		}
	}

	/*-----公共方法-----*/
	handleChange(key ,time) {
		let { startDate = '', endDate = '' } = this.state;
		const format = this.props.cmp_data.data_format.replace('yyyy','YYYY').replace('dd','DD');
		if(key == 'start') {
			startDate = time.format(format);
		}else{
			endDate = time.format(format);
		}
		this.setState({
			startDate: startDate
			,endDate: endDate
			,key: key
		},() => {
			let dateValue = startDate + '-' + endDate;
			this.props.onChange && this.props.onChange({
				text: dateValue
				,value: dateValue
			});
		});
	}

	/*-----全部筛选方法-----*/
	handleClear(key) {
		let { startDate = '', endDate = '' } = this.state;
		if(key == 'start') {
			startDate = '';
		}else{
			endDate = '';
		}
		this.setState({
			startDate: startDate
			,endDate: endDate
			,key
		},() => {
			const value = (startDate || endDate) ? (startDate + '-' + endDate) : '';
			this.props.onBlur && this.props.onBlur({
				text: value
				, value: value
			});
		});
	}

	/*-----筛选项方法-----*/
	formatDate(value) {
		const format = this.props.cmp_data.data_format.replace('yyyy','YYYY').replace('dd','DD');
		return value.format(format);
	}

	getDefaultDate() {
		const date = moment(new Date(new Date()));
        return this.formatDate(date);
	}

	setOrder(startDate, endDate) {
		const timeFormat = this.formatType == 'HH:mm' ? moment(new Date()).format('YYYY/MM/DD') + ' ' : '';
		return new Date(covertDateStrForNewDate(timeFormat + startDate,this.formatType) || new Date()) < new Date(covertDateStrForNewDate(timeFormat + endDate,this.formatType) || new Date()) ?
					startDate + '-' + endDate :
					endDate + '-' + startDate;
	}

	handleClearValue(e) {
		e.preventDefault();
		this.props.handleClosePopUp && this.props.handleClosePopUp();
		this.props.onChange && this.props.onChange({ text: '', value: '' });
		this.props.synBizData && this.props.synBizData();
	}

    handleSaveDate() {
    	this.props.handleClosePopUp && this.props.handleClosePopUp();
    	let dateValue;
        let { startDate = '', endDate = '' } = this.state;
        if(this.props.text == '' && (!startDate || !endDate)) {
            const date = moment(new Date(covertDateStrForNewDate(this.state.timeText,this.formatType) || new Date()));
            const dateText = this.formatDate(date);
			dateValue = this.defaultStartDate + '-' + this.defaultEndDate;
            this.setState({ startDate: dateText, endDate: dateText });
        }else if(startDate && endDate) {
			dateValue = this.setOrder(startDate,endDate);
        }else {
			const startText = startDate ? startDate : this.defaultStartDate;
			const endText = endDate ? endDate : this.defaultEndDate;
        	dateValue = this.setOrder(startText,endText);
        }
    	this.props.onChange && this.props.onChange({
			text: dateValue
			,value: dateValue
		});
        this.props.synBizData && this.props.synBizData();

	}

	onClickForm(key) {
    	if(this.props.pop_type == 'searchList ') {
    		return;
    	}
    	if(key == 'start') {
    		this.setState({ toBottom: false,key: key });
    	}else {
    		this.setState({ toBottom: true,key: key });
    	}
	}

	/*-----公共展示-----*/
	renderSwipeArrowForm(key, str) {
		const errMsg = this.props.errorMessage && this.props.errorMessage.message;
		const { startDate = '', endDate = '' } = this.state;
		const className = key == 'start' ? 'start_inputCls' : 'end_inputCls';
		const inputCls = this.props.pop_type == 'searchItem' && this.state.key == key ?
		       classNames({ 'inputCls_toBottom': this.state.toBottom }) : '';
		return (
			<div className={classNames('arrowDate', this.state.toBottom ? 'top' : 'bottom')}>
				<ArrowItem
					disablePrevent
					label={str + this.props.label}
					value={key == 'start' ? startDate : endDate}
					errorMsg={errMsg}
					required={this.props.required}
					cls={classNames(className, inputCls)}
					stateClass={this.props.stateClass}
					isReadOnly={this.props.isReadOnly}
					onClickForm={this.onClickForm.bind(this, key)}
					pop_type={this.props.pop_type}
					translation={this.translation}
                    styleTitle={this.props.styleTitle}
				/>
			</div>
		);
	}

	/*-----全部筛选展示-----*/
	getDatePicker(date,flag = 'startTime') {
		let time = this.state.startDate || this.defaultStartDate;
		if(flag === 'endTime') {
			time = this.state.endDate || this.defaultEndDate;
		}

		return (<DatePicker  className={'pre-datePicker ' + this.setdatePreCls()}
							defaultDate={moment(new Date(date ? covertDateStrForNewDate(date,this.formatType) : time))}
							mode={this.pickerMode}
							locale={zhCn(this.props.locale)}
							minuteStep={1}
							minDate={moment([1900,0,1,0,0,0])}
							maxDate={moment([2050,11,31,23,59,59])} />);
	}

	formatNormalDate(date) {
		if (this.formatType == 'HH:mm') {
			return date ? (moment(new Date()).format('YYYY/MM/DD') + ' ' + date) : moment(new Date()).format('YYYY/MM/DD HH:mm');
		}else if (this.formatType == 'yyyy/MM') {
			return date ? (date + '/' + pad(new Date().getDate())) : moment(new Date()).format('YYYY/MM/DD');
		}
		return date;
	}

	setdatePreCls() {
        let mode = {
            'time': 'pre-picker-time'  // 时分
            ,'date': 'pre-picker-date'  // 年月日
            ,'month': 'pre-picker-month'   // 年月
            ,'datetime': 'pre-picker-datetime'
        };
        return mode[this.pickerMode];
    }

	renderNormalDateRange() {
		let { startDate ,endDate } = this.state;
		const { translation } = this;
		startDate = this.formatNormalDate(startDate);
		endDate = this.formatNormalDate(endDate);
		const pickerArr = [{ 'popTitle': translation.dateRangeStartTime,'pickerName': this.getDatePicker(startDate,'startTime'),'actionName': 'start','formTitle': translation.dateRangeStart }
							,{ 'popTitle': translation.dateRangeEndTime,'pickerName': this.getDatePicker(endDate,'endTime'),'actionName': 'end','formTitle': translation.dateRangeEnd }];

		return (<div className='dt'>
					{pickerArr.map((item,index) => {
						return (<div className="dt-item" key={index}>
									<PopPicker
										datePicker={item.pickerName}
										transitionName="rmc-picker-popup-slide-fade"
										maskTransitionName="rmc-picker-popup-fade"
										title={item.popTitle}
										onDismiss={this.handleClear.bind(this,item.actionName)}
										onChange={this.handleChange.bind(this,item.actionName)}
										okText={translation.confirm}
										dismissText={translation.clear}>
										{this.renderSwipeArrowForm(item.actionName, item.formTitle)}
									</PopPicker>
								</div>);
					})}
			</div>
		);
	}

	/*-----筛选项展示-----*/
	renderDatePickerBtn() {
		const { translation } = this;
    	return (
    	    <Footer cls='searchItem-footer-border'>
                <Button cls='btn_empty' text={translation.clear} onTouchTap={this.handleClearValue} />
                <Button cls='btn_submit' text={translation.confirm} onTouchTap={this.handleSaveDate} />
            </Footer>
    	);
    }

    renderSearchItemDateRange() {
		const { translation } = this;
    	let dateTransformY;
        if(this.state.toBottom) {
        	dateTransformY = document.getElementsByClassName('end_inputCls')[0].offsetHeight - 3;
        }
        const dateContentStyle = this.state.toBottom ?
                                 { transform: 'translateY(' + dateTransformY + 'px)',WebkitTransform: 'translateY(' + dateTransformY + 'px)', transition: 'transform .5s' } :
								 { transform: 'translateY(0px)',WebkitTransform: 'translateY(0px)', transition: 'transform .5s' };
		let { startDate ,endDate } = this.state;
		startDate = this.formatNormalDate(startDate);
		endDate = this.formatNormalDate(endDate);
		const currentDate = this.state.toBottom ? endDate : startDate;

        return (
            <div>
                {this.renderSwipeArrowForm('start', translation.dateRangeStart)}
                <div className={classNames('date_range')} style={dateContentStyle}>
					<DatePicker className={'pre-datePicker ' + this.setdatePreCls()}
								defaultDate={moment(new Date(startDate ? covertDateStrForNewDate(startDate,this.formatType) : this.defaultStartDate))}
								date={moment(new Date(currentDate ? covertDateStrForNewDate(currentDate,this.formatType) : this.state.toBottom ? this.defaultEndDate : this.defaultStartDate))}
								mode={this.pickerMode}
								locale={zhCn(this.props.locale)}
								minuteStep={1}
								minDate={moment([1900,0,1,0,0,0])}
								maxDate={moment([2050,11,31,23,59,59])}
								onDateChange={this.handleChange.bind(this,this.state.key)}

					/>
				</div>
				{this.renderSwipeArrowForm('end', translation.dateRangeEnd)}
				{this.renderDatePickerBtn()}
            </div>
        );
    }
	render() {
		return this.props.pop_type == 'searchItem' ? this.renderSearchItemDateRange() :
		       this.renderNormalDateRange();
	}
}
export default DateRange;



// WEBPACK FOOTER //
// ./src/components/Field_Components/DateRange/DateRange.js